export default {
  index: [
    {
      path: '/qymanage',
      component: resolve => require(['./qymanageIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qymanage/_router.js